<template>
  <div>
    <div class="row border-bottom border-secondary mb-1">
      <Aguarde :show="httpSend"></Aguarde>
      <div class="col-12">
        <b-form @submit.prevent="selectChange()">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Ano" label-for="not_emissao_ano">
                <input
                    id="not_emissao_ano"
                    v-model="filtro.not_emissao_ano"
                    v-mask="'####'"
                    type="text"
                    maxlength="4"
                    class="form-control"
                    placeholder="Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Números Finais"
                  label-for="fnot_numero">
                <input
                    id="fnot_numero"
                    v-model="filtro.not_numero"
                    type="text"
                    maxlength="11"
                    class="form-control"
                    placeholder="Números após os zeros">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Competência Inicial"
                  label-for="sep_competencia_inicial">
                <input
                    id="sep_competencia_inicial"
                    v-model="filtro.sep_competencia_inicial"
                    v-mask="'##/####'"
                    type="text"
                    maxlength="7"
                    class="form-control"
                    placeholder="Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Competência Final"
                  label-for="sep_competencia_final">
                <input
                    id="sep_competencia_final"
                    v-model="filtro.sep_competencia_final"
                    v-mask="'##/####'"
                    type="text"
                    maxlength="7"
                    class="form-control"
                    placeholder="Mês/Ano">
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                  label="Emissão Incial"
                  label-for="not_emissao_incial">
                <input
                    id="not_emissao_incial"
                    v-model="filtro.not_emissao_incial"
                    type="date"
                    maxlength="10"
                    class="form-control"
                    placeholder="Dia/Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Emissão Final"
                  label-for="not_emissao_final">
                <input
                    id="not_emissao_final"
                    v-model="filtro.not_emissao_final"
                    type="date"
                    maxlength="10"
                    class="form-control"
                    placeholder="Dia/Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Nº Nota Inicial"
                  label-for="not_numero_inicial">
                <input
                    id="not_numero_inicial"
                    v-model="filtro.not_numero_inicial"
                    type="text"
                    v-mask="'###############'"
                    maxlength="15"
                    class="form-control"
                    placeholder="Número completo">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Nº Nota Final"
                  label-for="not_numero_final">
                <input
                    id="not_numero_final"
                    v-model="filtro.not_numero_final"
                    type="text"
                    maxlength="15"
                    v-mask="'###############'"
                    class="form-control"
                    placeholder="Número completo">
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Tributação" label-for="sep_exigibilidade_iss">
                <select id="sep_exigibilidade_iss"
                        @change="selectChange()"
                        v-model="filtro.sep_exigibilidade_iss"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="1">Exigível</option>
                  <option value="2">Não Incidência</option>
                  <option value="3">Isenção</option>
                  <option value="5">Imune</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Situação" label-for="not_cancelada">
                <select id="not_cancelada"
                        @change="selectChange()"
                        v-model="filtro.not_cancelada"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="1">Emitida</option>
                  <option value="2">Cancelada</option>
                  <option value="99">Aguardando Pagamento</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Exigibilidade" label-for="sep_municipio_incidencia">
                <select id="sep_municipio_incidencia"
                        @change="selectChange()"
                        v-model="filtro.sep_municipio_incidencia"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option v-bind:value="'='+entidade.mun_codigo">No Município</option>
                  <option v-bind:value="'<>'+entidade.mun_codigo">Fora do Município</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="ISS Retido" label-for="sep_iss_retido">
                <select id="sep_iss_retido"
                        @change="selectChange()"
                        v-model="filtro.sep_iss_retido"
                        class="custom-select" type="text">
                  <option value="">Todos</option>
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                  label="Nome/Razão Tomador"
                  label-for="fsep_razao_social_tomador">
                <input
                    id="fsep_razao_social_tomador"
                    v-model="filtro.sep_razao_social_tomador"
                    type="text"
                    maxlength="20"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                  label="CPF/CNPJ do Tomador">
                <the-mask class="form-control" v-model="filtro.sep_cpf_cnpj_tomador"
                          :mask="['###.###.###-##', '##.###.###/####-##']"/>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Solicitação de Nota" label-for="tipo_avulsa">
                <select id="tipo_avulsa"
                        @change="selectChange()"
                        v-model="filtro.tipo_avulsa"
                        class="custom-select" type="text">
                  <option value="1">Exibir</option>
                  <option value="0">Não Exibir</option>
                </select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Ordenação" label-for="nota_pagina">
                <select id="nota_pagina"
                        @change="selectChange()"
                        v-model="filtro.ordenacao"
                        class="custom-select" type="text">
                  <option value="n.not_emissao desc">Data de Emissão ↓</option>
                  <option value="n.not_emissao">Data de Emissão ↑</option>
                  <option value="sp.sep_valor desc">Valor da Nota ↓</option>
                  <option value="sp.sep_valor">Valor da Nota ↑</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Notas por Página" label-for="nota_pagina">
                <select id="nota_pagina"
                        @change="selectChange()"
                        v-model="filtro.nota_pagina"
                        class="custom-select" type="text">
                  <option value="10">10/Pág.</option>
                  <option value="30">30/Pág.</option>
                  <option value="50">50/Pág.</option>
                  <option value="80">80/Pág.</option>
                  <option value="100">100/Pág.</option>
                  <option value="200">200/Pág.</option>
                  <option value="500">500/Pág.</option>
                  <option value="800">800/Pág.</option>
                  <option value="1000">1000/Pág.</option>
                </select>
              </b-form-group>
            </div>
            <b-form-group
                label="'"
                class="text-white">
              <button type="button"
                      @click="lote_xml"
                      class="btn btn-label btn-info"><i
                  class="bx bx-download label-icon"></i>
                Baixar XML
              </button>
            </b-form-group>
            <b-form-group
                label="'"
                class="text-white">
              <button type="submit"
                      class="btn btn-label btn-primary ml-3"><i
                  class="bx bx-search label-icon"></i>
                Consultar
              </button>
            </b-form-group>
          </div>
        </b-form>
      </div>
    </div>
    <div class="row border-bottom border-secondary mb-1">
      <p class="mb-2 font-weight-medium">Total de Notas: {{ resumo.total }} | Valor Total NFS-e:
        {{ resumo.valor_notas | formatNumeroBr }} | Valor Total ISS: {{ resumo.valor_iss | formatNumeroBr }} </p>
    </div>
    <div v-show="!list_notas || list_notas.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem notas
    </div>
    <div v-for="g in list_avulsas" :key="g.reb_codigo" class="row">
      <div class="col-md-12 mb-3 border-bottom border-secondary">
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Recibo Provisório">
              <h6 class="mb-0 text-body font-weight-bold">
                {{ g.reb_numero }}
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Emissão - Competência">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ g.reb_emissao | formatDate }} - </span>
                <span class="text-body font-weight-bold">{{ g.sep_competencia | formatDateCompetencia }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Situação">
              <h6 class="mb-0">
                <span class="badge badge-warning font-size-12">Aguardando Pagamento</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div v-if="g.sep_cpf_cnpj_tomador" class="col-md-4">
            <b-form-group label="CPF/CNPJ Tomador">
              <h6 class="mb-0">
                <span v-if="g.sep_cpf_cnpj_tomador.length < 12">{{
                    g.sep_cpf_cnpj_tomador | VMask('###.###.###-##')
                  }}</span>
                <span v-else>{{ g.sep_cpf_cnpj_tomador| VMask('##.###.###/####-##') }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Nome/Razao Social Tomador">
              <h6 class="mb-0">{{ g.sep_razao_social_tomador }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Valor da Nota">
              <h6 class="mb-0">{{ g.sep_valor | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="button" @click="pagamento(g)" class="btn btn-success btn-sm mb-2 mr-2">
              <i class="bx bx-money"></i> Realizar Pagamento
            </button>
            <button v-if="!g.soc_codigo" type="button" @click="modalCancelar(g)"
                    class="btn btn-outline-danger btn-sm mb-2 mr-2">
              <i class="mdi mdi-cancel"></i> Cancelar Solicitação
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-for="g in list_notas" :key="g.tps_codigo" class="row">
      <div class="col-md-12 mb-3 border-bottom border-secondary">
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Nota Fiscal">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold" v-if="!g.not_numero">-</span>
                <span class="text-body font-weight-bold" v-else>{{ g.not_numero }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Emissão - Competência">
              <h6 class="mb-0">
                <span v-if="!g.not_emissao"> - </span>
                <span class="text-body font-weight-bold" v-else>{{ g.not_emissao | formatDateHora }} - </span>
                <span class="text-body font-weight-bold">{{ g.sep_competencia | formatDateCompetencia }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Situação">
              <h6 class="mb-0">
                <span v-show="g.soc_codigo" class="badge badge-danger font-size-12">Cancelada</span>
                <span v-show="g.not_numero && !g.soc_codigo" class="badge badge-success font-size-12">Emitida</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div v-if="g.sep_cpf_cnpj_tomador" class="col-md-4">
            <b-form-group label="CPF/CNPJ Tomador">
              <h6 class="mb-0">
                <span v-if="g.sep_cpf_cnpj_tomador.length < 12">{{
                    g.sep_cpf_cnpj_tomador | VMask('###.###.###-##')
                  }}</span>
                <span v-else>{{ g.sep_cpf_cnpj_tomador| VMask('##.###.###/####-##') }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Nome/Razao Social Tomador">
              <h6 class="mb-0">{{ g.sep_razao_social_tomador }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Valor da Nota">
              <h6 class="mb-0">{{ g.sep_valor | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <router-link
                class="btn btn-dark btn-sm mb-2 mr-2"
                tag="a"
                :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.not_hash}}">
              <i class="mdi mdi-file-pdf-outline"></i> Visualizar
            </router-link>
            <button type="button" @click="baixar_nota(g)" class="btn btn-secondary btn-sm mb-2 mr-2">
              <i class="mdi mdi-file-pdf-outline"></i> Baixar PDF
            </button>
            <button type="button" @click="baixar_xml(g)" class="btn btn-info btn-sm mb-2 mr-2">
              <i class="mdi mdi-file-excel-outline"></i> Baixar XML
            </button>

            <router-link
                v-if="g.soc_motivo && g.substituicao"
                class="btn btn-outline-dark btn-sm mb-2 mr-2"
                tag="a"
                :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.substituicao}}">
              <i class="mdi mdi-file-pdf-outline"></i> Visualizar nota Substituta
            </router-link>

            <router-link
                v-if="g.substituida"
                class="btn btn-outline-dark btn-sm mb-2 mr-2"
                tag="a"
                :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.substituida}}">
              <i class="mdi mdi-file-pdf-outline"></i> Visualizar nota Substituída
            </router-link>

            <button v-if="!g.soc_codigo && !g.substituicao" type="button" @click="substituir(g)"
                    class="btn btn-outline-warning btn-sm mb-2 mr-2">
              <i class="mdi mdi-replay"></i> Substituir
            </button>
            <button v-if="!g.soc_codigo" type="button" @click="modalCancelar(g)"
                    class="btn btn-outline-danger btn-sm mb-2 mr-2">
              <i class="mdi mdi-cancel"></i> Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="list_notas && list_notas.length > 0" class="row">
      <div class="col-lg-12">
        <paginate
            v-model="filtro.pagina"
            :page-count="total_paginas"
            :page-range="3"
            :margin-pages="3"
            :click-handler="proximaPagina"
            :prev-text="'Página anterior'"
            :next-text="'Próxima página'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
            :page-link-class="'page-link'"
            :container-class="'pagination pagination-rounded justify-content-center mt-4'"
            :page-class="'page-item'">
        </paginate>
      </div>
    </div>
    <b-modal
        id="modal-cancela-nota"
        ref="modal-cancela-nota"
        size="xl"
        title="Cancelar Nota Fiscal"
        title-class="font-18"
        :hide-header-close="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true">
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Nota Fiscal" label-for="not_numero">
              <input id="not_numero"
                     :value="nota.not_numero"
                     v-bind:disabled="true"
                     type="text"
                     class="form-control">
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Emissão" label-for="not_emissao">
              <input id="not_emissao"
                     :value="nota.not_emissao | formatDate"
                     v-bind:disabled="true"
                     type="text"
                     class="form-control">
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group label="Tomador" label-for="sep_razao_social_tomador">
              <input id="sep_razao_social_tomador"
                     :value="nota.sep_razao_social_tomador"
                     v-bind:disabled="true"
                     type="text"
                     class="form-control">
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <b-form-group label="Motivo do Cancelamento" label-for="soc_motivo">
              <select id="soc_motivo"
                      v-model="cancelamento.soc_motivo" class="custom-select"
                      :class="{ 'is-invalid': $v.cancelamento.soc_motivo.$error }" type="text">
                <option value="1">Competência incorreta</option>
                <option value="2">Divergência do tomador</option>
                <option value="3">Duplicidade de emissão para o mesmo fato gerador do serviço</option>
                <option value="4">Serviço não prestado</option>
              </select>
              <div v-if="$v.cancelamento.soc_motivo.$error" class="invalid-feedback">
                Informe o motivo do cancelamento
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="NFS-e emitida corretamente" label-for="soc_nota_correta">
              <input
                  id="bairro"
                  v-model="cancelamento.soc_nota_correta"
                  type="text"
                  maxlength="15"
                  class="form-control"
                  :class="{ 'is-invalid': erros.nota_correta }"
                  placeholder="Número da nota correta">
              <div v-if="erros.nota_correta" class="invalid-feedback">
                Informe o número da nota correta
              </div>
            </b-form-group>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Justificativa do cancelamento" label-for="soc_motivo">
                        <textarea
                            v-model="cancelamento.soc_justificativa"
                            class="form-control"
                            :class="{'is-invalid': $v.cancelamento.soc_justificativa.$error }"
                            :maxlength="200"
                            rows="4"
                            placeholder="Descrição do serviço máximo de 200 caracteres"
                        ></textarea>
              <div class="text-center">
                <p v-if="cancelamento.soc_justificativa" class="badge position-absolute"
                   :class="{ 'badge-success': cancelamento.soc_justificativa.length !== 2000,
                            'badge-danger': cancelamento.soc_justificativa.length === 2000 }">
                  {{ cancelamento.soc_justificativa.length }} / 200
                </p>
              </div>
              <h6 v-show="$v.cancelamento.soc_justificativa.$error" class="invalid-feedback">
                Informe a justificativa do cancelamento</h6>
            </b-form-group>
          </div>
        </div>
        <div v-show="!cancelamento_automatico" class="row">
          <div class="col-md-12">
            <b-form-group label="Arquivo da declaração do tomador / NFS-e de origem" label-for="soc_nota_correta">
              <vue-dropzone id="dropzone"
                            ref="myVueDropzone"
                            v-on:vdropzone-processing="sendFileProcessing"
                            v-on:vdropzone-success="sendFileComplete"
                            v-on:vdropzone-removed-file="sendFileRemove"
                            :options="dropzoneOptions"></vue-dropzone>
              <div class="text-muted">
                Somente arquivo pdf com tamanho máximo de 2MB.
              </div>
              <div v-if="erros.arquivo" class="text-danger">
                Necessário enviar o arquivo
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <button v-if="httpSendFile" type="button" disabled class="btn btn-success"><i
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i> Carregando
        </button>
        <b-button v-else variant="success" @click="cancelarNota()">
          Cancelar Nota
        </b-button>
        <b-button variant="dark" @click="closeModal('modal-cancela-nota')">
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import {required} from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import {TheMask} from 'vue-the-mask'
import Aguarde from "@/components/widgets/aguarde";
import {cancelarNota, downloadLoteXML, downloadNota, downloadNotaXML, listNotas} from "@/api/nfse/nota";
import Swal from "sweetalert2";
import {getEntidade} from "@/api/config/init";
import {getToken} from "@/api/config/token";
import {uploadCancelamento} from "@/api/core/upload";
import moment from "moment";
import router from "@/router";

export default {
  components: {
    Aguarde,
    TheMask,
    Paginate,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      list_notas: [],
      list_avulsas: [],
      httpSend: false,
      httpSendFile: false,
      filtro: {
        eco_codigo: null,
        ordenacao: "n.not_emissao desc",
        pagina: 1,
        nota_pagina: "10",
        not_emissao_ano: "",
        not_numero: "",
        sep_competencia_inicial: "",
        sep_competencia_final: "",
        not_emissao_incial: moment().startOf('year').format('YYYY-MM-DD'),
        not_emissao_final: moment().format('YYYY-MM-DD'),
        not_numero_inicial: "",
        not_numero_final: "",
        sep_exigibilidade_iss: "",
        not_cancelada: "",
        sep_municipio_incidencia:"",
        sep_iss_retido: "",
        sep_cpf_cnpj_tomador: "",
        sep_razao_social_tomador: "",
        tipo_avulsa: "1",
      },
      resumo: {
        total: 0,
        valor_notas: 0,
        valor_iss: 0
      },
      total_paginas: 0,
      nota: {},
      cancelamento_automatico: false,
      cancelamento: {
        soc_codigo: null,
        soc_motivo: '',
        soc_justificativa: '',
        not_codigo: null,
        soc_nota_correta: null,
        soc_arquivo: ''
      },
      erros: {
        nota_correta: false,
        arquivo: false
      },
      dropzoneOptions: {
        dictFileTooBig: "O arquivo é muito grande ({{filesize}}MB). Tamanho máximo permitido: {{maxFilesize}}MB",
        dictRemoveFile: "Clique aqui para remover",
        dictCancelUpload: "Cancelar envio",
        dictCancelUploadConfirmation: "Tem certeza de que deseja cancelar o envio ?",
        dictMaxFilesExceeded: "Você não pode enviar mais arquivos",
        url: uploadCancelamento(),
        paramName: "arquivo",
        createImageThumbnails: false,
        acceptedFiles: "application/pdf",
        disablePreviews: true,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='mdi mdi-upload'></i> Solte o arquivo, ou clique aqui para selecionar",
        headers: {"X-ACCESS-ENTIDADE": getEntidade(), "X-ACCESS-TOKEN": getToken()}
      }
    };
  },
  validations: {
    cancelamento: {
      soc_motivo: {
        required
      },
      soc_justificativa: {
        required,
      },
    },
  },
  created() {
    if (this.empresa) {
      this.filtro.eco_codigo = this.empresa.eco_codigo;
      if (this.$route.query.nota_pagina) {
        this.filtro = this.$route.query;
        this.filtro.pagina = parseInt(this.filtro.pagina)
        this.getNota();
      } else {
        this.getNota();
      }
    }
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  methods: {
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = pageNum;
      this.getNota()
    },
    resetCancelamento() {
      this.cancelamento = {
        soc_codigo: null,
        soc_motivo: '',
        soc_justificativa: '',
        not_codigo: null,
        soc_nota_correta: null,
        soc_arquivo: ''
      }
      this.erros.arquivo = false;
      this.erros.nota_correta = false;
    },
    sendFileProcessing(file) {
      this.httpSendFile = true;
      console.log("file", file)
    },
    sendFileComplete(file, response) {
      if (response.status) {
        this.cancelamento.soc_arquivo = response.dados
      } else {
        const msg = response.mensagem;
        if (typeof msg === 'object') {
          this.$toast.error(JSON.stringify(msg));
        } else {
          this.$toast.error(msg);
        }
        this.$refs.myVueDropzone.removeAllFiles()
      }
      this.httpSendFile = false;
    },
    sendFileRemove(file, error) {
      this.cancelamento.soc_arquivo = '';
      console.log(file)
      console.log(error)
    },
    getNota() {
      this.httpSend = true;
      listNotas(this.empresa.eco_codigo, this.filtro).then(result => {
        this.resumo = result.dados.resumo;
        this.total_paginas = result.dados.paginas;
        this.list_notas = result.dados.notas;
        this.list_avulsas = result.dados.avulsas;
        router.replace({query: {...this.filtro, t: new Date().getTime().toString()}})
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    selectChange() {
      this.filtro.pagina = 1;
      this.getNota();
    },
    detalhe(nota) {
      this.$router.push({
        name: 'admin-liberacao-pessoa-detalhe',
        params: {tps_hash: nota.tps_hash}
      })
    },
    substituir(nota) {
      let prazo = parseInt(this.entidade.par_prazo_subistituir)
      let dias_emissao = parseInt(nota.dias_emissao)
      if (dias_emissao > prazo) {
        Swal.fire({
          icon: 'info',
          title: 'Prazo Excedido',
          text: 'Excedido o prazo de ' + this.entidade.par_prazo_subistituir + ' dias para realizar a substituição',
          confirmButtonText: 'Fechar'
        })
      } else {
        this.$router.push({
          name: 'contribuinte-nota-fiscal-substituir',
          params: {not_hash: nota.not_hash}
        })
      }
    },
    modalCancelar(nota) {
      this.prazoCancelamento(nota);
      this.nota = nota;
      this.$refs['modal-cancela-nota'].show();
    },
    prazoCancelamento(nota) {
      const prazo = parseInt(this.entidade.par_prazo_autocancelar)
      if (prazo < 1) {
        this.cancelamento_automatico = false;
      } else {
        const dias_emissao = parseInt(nota.dias_emissao)
        this.cancelamento_automatico = (dias_emissao <= prazo);
      }
    },
    cancelarNota() {
      this.erros.arquivo = false;
      this.erros.nota_correta = false;
      this.$v.$touch();
      if (this.$v.cancelamento.$invalid) {
        return false;
      }
      if (this.cancelamento.soc_motivo === '3') {
        if (!this.cancelamento.soc_nota_correta || this.cancelamento.soc_nota_correta === '') {
          this.erros.nota_correta = true;
          return false;
        }
      }
      if (!this.cancelamento_automatico && this.cancelamento.soc_arquivo === '') {
        this.erros.arquivo = true;
        return false;
      }
      this.cancelamento.not_codigo = this.nota.not_codigo;
      this.httpSend = true;
      cancelarNota(this.cancelamento).then(result => {
        if (result.status) {
          this.getNota();
          this.$toast.success(result.mensagem)
          this.closeModal('modal-cancela-nota');
          this.resetCancelamento();
        } else {
          this.$toast.error(result.mensagem);
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    closeModal(ref) {
      this.nota = {};
      this.$refs[ref].hide();
    },
    visualiza_nota(not_hash) {
      this.$router.push({name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: not_hash}})
    },
    baixar_nota(nota) {
      this.httpSend = true;
      downloadNota(nota.not_hash).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    baixar_xml(nota) {
      this.httpSend = true;
      downloadNotaXML(nota.not_hash).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    lote_xml() {
      if (this.filtro.nota_pagina !== '') {
        Swal.fire({
          title: "Atenção apenas as notas exibidas na tela serão baixas.",
          html: 'Para baixar todas as notas selecione "Sem Limite" no campo "Notas por Página".<br> Deseja baixar somente as notas exibidas na tela ?',
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#100e0e",
          confirmButtonText: "Sim",
          cancelButtonText: "Não"
        }).then(result => {
          if (result.isConfirmed) {
            this.baixar_lote_xml();
          }
        });
      } else {
        this.baixar_lote_xml();
      }
    },
    baixar_lote_xml() {
      this.httpSend = true;
      downloadLoteXML(this.filtro).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    pagamento(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-pagamento",
        params: {dam_hash: guia.dam_hash}
      })
    },
  }
};
</script>

<style>
.dropzone .dz-preview {
  display: inherit;
}

.vue-dropzone > .dz-preview .dz-remove {
  padding: 5px;
  bottom: 5px;
}
</style>
